class HttpError extends Error {
    status_code;
    res;

    constructor(status_code, message, res) {
        super(message);
        this.status_code = status_code;
        this.res = res;
    }

    static fromResponse( res ) {
        if (res.text) {
            return new HttpError(res.status, res.text, res);
        }
        const {errors} = res.json;
        return new HttpError(res.status, errors.messages[0], res);
    }
}

function request(input, init) {
    // noinspection JSUnresolvedVariable
    const {nonce, api} = window.pay;

    if (input.startsWith('/')) {
        input = api + input;
    }
    init = init || {};
    init.headers = init.headers || {};
    init.credentials = 'include';
    if (nonce) {
        init.headers['X-WP-Nonce'] = nonce;
    }

    return fetch(input, init)
        .then(response => {
            if (response.status === 204) {
                return {
                    status: response.status,
                    body: {
                        status: true
                    }
                };
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json().then(data => ({status: response.status, json: data}));
            } else {
                /* Allow text API but currently only used for errors */
                return response.text().then(text => ({status: response.status, text: text}));
            }
        }).then(data => {
            if (data.status >= 400) {
                throw HttpError.fromResponse(data);
            }
            const {status} = data.json;
            if (!status) {
                throw HttpError.fromResponse(data);
            }
            return (data.text !== undefined) ? data.text : data.json;
        }).catch(e => {
            throw new HttpError(0, e.toString(), e);
        });
}

function patch(url, data) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return request(url, requestOptions);
}

function post(url, data) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return request(url, requestOptions);
}

function get(url) {
    const requestOptions = {
        method: 'GET'
    };
    return request(url, requestOptions);
}

module.exports = {
    get,
    patch,
    post,
    request,
    HttpError,
};